import InHospitalDialog from '../components/InHospitalDialog.vue';
import gql from 'graphql-tag';

export default {
  data() {
    return {
      isShowInHospital: false,
      toDialoPatientsData: {},
      openHospitalId: null,
      lastDiagnosisText: {
        bool: false,
        id: 0,
      },
    }
  },
  components: {
    InHospitalDialog
  },
  methods: {
    // 请求最近一次诊断的诊断结果
    getLastDiagnosisText(patientId) {
      this.lastDiagnosisText = {
        bool: !this.lastDiagnosisText.bool,
        id: patientId,
      };
    },
    async newInHospotal(event, item) {
      event.cancelBubble = true;
      // 请求一下住院号
      item.medical_record_num = await this.getMedicalRecordNum(item.id);
      this.toDialoPatientsData = item;
      this.isShowInHospital = true;
      this.getLastDiagnosisText(item.id);
    },
    setInHpspitalStatus(data) {
      // this.$emit('setInHpspitalStatus',val)
      this.isShowInHospital = data;
      if (!data) {
        this.openHospitalId = null;
      }
    },
    getInHospital(elId, item) {
      // console.log(elId,item)
      this.openHospitalId = elId;
      this.isShowInHospital = true;
      this.toDialoPatientsData = item
    },
    async refreshHandler(data) {
      await this.changeHandler(data);
      // console.log(data)
    },
    // 获取住院号
    async getMedicalRecordNum(patientId) {
      try {
        const res = await this.$apollo.query({
          query: gql`{
            patient(id: ${patientId}){
              id
              medical_record_num
            }
          }`,
          fetchPolicy: "no-cache",
        });
        return res.data.patient.medical_record_num;
      } catch (error) {
        this.$message.error('住院号获取失败');
        return '';
      }
    },
  },
}
